export default __webpack_public_path__ + "static/media/step1.bba0f1f8.png";